export const SNACKBAR_DURATION = 5000

export const SNACKBAR_FADE_DURATION = 300
